// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoTiles_root__uSWuH","headline":"InfoTiles_headline__W4aEq"};